/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The charge point state
 */
export enum ChargePointState {
  AVAILABLE = 'AVAILABLE',
  PARTIALLY_AVAILABLE = 'PARTIALLY_AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  OUT_OF_ORDER = 'OUT_OF_ORDER',
  IN_MAINTENANCE = 'IN_MAINTENANCE',
  UNKNOWN = 'UNKNOWN'
}
